<template>
    <div class="app-header-login">
        <nuxt-link class="px-5 py-3 text-base font-bold leading-6 text-white" to="/login"> Login </nuxt-link>
    </div>
</template>

<script>
export default {
    name: 'AppHeaderLogin',
};
</script>
